import { render } from "./OssConfig.vue?vue&type=template&id=9f3d4a54&scoped=true"
import script from "./OssConfig.vue?vue&type=script&lang=js"
export * from "./OssConfig.vue?vue&type=script&lang=js"

import "./OssConfig.vue?vue&type=style&index=0&id=9f3d4a54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f3d4a54"]])

export default __exports__